import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';
import './CompareResultsCard.scss';

const SearchCoveredCard = () => {
  return (
    <Card className="">
      <Row className=" align-items-center">
        <Col md={6} xs={12}>
          <Row className="align-items-center">
            <Col md={5} xs={12} className="p-0 m-0">
              <Skeleton
                height={12}
                count={5}
                width={800}
                containerClassName={'name-address-info'}
              />
            </Col>
          </Row>
        </Col>
        <Col md={6} xs={12}>
          <div className="text-right">
            <Skeleton
              height={130}
              width={300}
              count={1}
              containerClassName={'name-address-info'}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default SearchCoveredCard;
